import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".element-largevideo").forEach((el) => {
  const wrapper = el.querySelector(".video-wrapper");
  const trigger = el.querySelector(".video-trigger");

  gsap
    .timeline({
      paused: true,
      scrollTrigger: {
        trigger: wrapper,
        start: "25% center",
        markers: false,
      },
    })
    .to(wrapper, { width: "100%", duration: 0.5, ease: "expoScale(0.5, 7, none)" })
    .to(trigger, { opacity: 1, duration: 0.3, ease: "expoScale(0.5, 7, none)" });
});
